module.exports = __webpack_public_path__ + "static/img/choose_2_1.9c87898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/choose_2_1.png
// module id = MG4F
// module chunks = 0